import axios from "axios";

import { AccountData, LoginRequest, newUserRequest } from "js/components/types";

import { AxiosInstance } from "../utils/AxiosInstance";

export const revokeExpressToken = async (advisorId: string) => {
  await AxiosInstance.put(`/v1/accounts/auth/token/revoke/${advisorId}`);
};

export const regenerateExpressToken = async (advisorId: string) => {
  const { data } = await AxiosInstance.put(
    `/v1/accounts/auth/token/regenerate/${advisorId}`,
  );
  return data;
};

export const regenerateMultireportToken = async (advisorId: string) => {
  const { data } = await AxiosInstance.put(
    `/v1/accounts/auth/token/mr/regenerate/${advisorId}`,
  );
  return data;
};

export const regenerateSicToken = async (advisorId: string) => {
  const { data } = await AxiosInstance.put(
    `/v1/accounts/auth/token/sic/regenerate/${advisorId}`,
  );
  return data;
};

export const getAdvisorData = async () => {
  const { data } = await AxiosInstance.get(`/v1/accounts/advisor/retrieve`);
  return data;
};

export const getAdvisorCredits = async () => {
  const { data } = await AxiosInstance.get(`/v1/accounts/advisor/quotes`);
  return data;
};

export const updateAdvisor = async (advisorId: string, data: AccountData) => {
  return await AxiosInstance.put(`/v1/accounts/user/${advisorId}/edit`, data);
};

export const logIn = async (data: LoginRequest) => {
  return await AxiosInstance.post(`/v1/accounts/user/login`, data);
};

export const createUser = async (userData: newUserRequest) => {
  return await AxiosInstance.post(`/v1/accounts/user/register`, userData);
};

export const forgotPassword = async (email: string) => {
  return await AxiosInstance.post(`/v1/accounts/user/forgot-password`, email);
};

export const changePassword = async (data: any) => {
  return await AxiosInstance.post(`/v1/accounts/user/change-password`, data);
};

export const getFullVerificationToken = async (short_code: string) => {
  return await AxiosInstance.get(
    `/v1/accounts/user/get-full-token/${short_code}`,
  );
};

export const verifyAccount = async (verification_token: string) => {
  return await AxiosInstance.post(
    `/v1/accounts/user/verify/${verification_token}`,
  );
};

export const resendVerificationEmail = async () => {
  return await AxiosInstance.post(`/v1/accounts/user/verify/resend-email`);
};

export const getReferralCode = async () => {
  const { data } = await AxiosInstance.get(`/v1/referrals/get`);
  return data;
};

export const sendReferralEmail = async (data: any) => {
  return await AxiosInstance.post(`/v1/referrals/invite`, data);
};

export const resetPassword = async (
  data: any,
  uidb64: string,
  token: string,
) => {
  const allData = { ...data, uidb64, token };
  const baseApiUrl = import.meta.env.VITE_APP_BASE_URL;
  return await axios.post(
    `${baseApiUrl}/v1/accounts/user/reset-password`,
    allData,
  );
};
